import { motion } from "framer-motion";
import { useLanguage } from "@/components/sybrax/LanguageProvider";
import { content } from "@/components/sybrax/i18n";

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const SectionLabel = ({ children }) => (
    <span className="inline-flex items-center text-xs font-semibold uppercase tracking-[0.25em] text-cyan-600 dark:text-cyan-400">
        <span className="mr-3 h-px w-8 bg-cyan-500/70 dark:bg-cyan-400/60" />
        {children}
    </span>
);

const About = () => {
    const { lang } = useLanguage();
    const about = content[lang].about;

    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="pointer-events-none absolute top-1/2 -left-32 w-[420px] h-[420px] rounded-full bg-cyan-500/[0.07] blur-[120px]" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeUp}
                    className="grid lg:grid-cols-12 gap-12 lg:gap-16"
                >
                    <div className="lg:col-span-4">
                        <SectionLabel>{about.label}</SectionLabel>
                        <h2
                            data-testid="about-title"
                            className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 dark:text-white"
                        >
                            {about.title}
                        </h2>
                        <p className="mt-5 text-sm text-slate-500 dark:text-slate-500 leading-relaxed">
                            {about.note}
                        </p>
                    </div>

                    <div className="lg:col-span-8 space-y-6 text-slate-700 dark:text-slate-400 text-base sm:text-lg leading-relaxed border-l border-slate-200/80 dark:border-white/5 pl-6 lg:pl-10">
                        <p data-testid="about-paragraph-1">{about.p1}</p>
                        <p data-testid="about-paragraph-2">{about.p2}</p>
                        <p data-testid="about-paragraph-3">{about.p3}</p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default About;
